import { Image } from "@fluentui/react-components";
import { QuestionCircleRegular } from "@fluentui/react-icons";

const apiUrl = process.env.REACT_APP_API_URL?.trim();

const CiTypeTemplate = ({ ciType }) => {
  console.debug("Rendering CiTypeTemplate for", ciType);
  return (
    <div style={{ display: "inline-flex", alignItems: "center", gap: "8px" }}>
      <div style={{ width: `${ciType.level * 7}px` }} />
      {ciType?.icon_url ? (
        <Image src={`${apiUrl}/citypes/${ciType.public_id}/icon`} height="20px" />
      ) : (
        <QuestionCircleRegular />
      )}
      <span>{ciType.name}</span>
    </div>
  );
};

export { CiTypeTemplate };
